import { FormCard } from '@qbe/ads-blocks-forms';
import React, { ReactNode } from 'react';

import ReviewBreakdown from '~/components/ReviewBreakdown';
import ReviewBuildingAndContents from '~/components/ReviewBuildingAndContents';
import ReviewBusinessInterruptions from '~/components/ReviewBusinessInterruptions';
import ReviewGlass from '~/components/ReviewGlass';
import ReviewMoney from '~/components/ReviewMoney';
import ReviewPortableItems from '~/components/ReviewPortableItems';
import ReviewTaxAudit from '~/components/ReviewTaxAudit';
import ReviewTheft from '~/components/ReviewTheft';
import { Cover } from '~/types/cover';

import { RemoveCoverButton } from './RemoveCoverButton';

const completionMap: Record<Cover, { component: ReactNode; dependantCovers?: readonly Cover[] }> = {
  [Cover.BuildingAndContents]: {
    component: <ReviewBuildingAndContents />,
    dependantCovers: [Cover.BusinessInterruption],
  },
  [Cover.BusinessInterruption]: {
    component: <ReviewBusinessInterruptions />,
  },
  [Cover.PortableItems]: {
    component: <ReviewPortableItems />,
  },
  [Cover.Theft]: {
    component: <ReviewTheft />,
  },
  [Cover.Money]: {
    component: <ReviewMoney />,
  },
  [Cover.Glass]: {
    component: <ReviewGlass />,
  },
  [Cover.Liability]: {
    component: null,
  },
  [Cover.Breakdown]: {
    component: <ReviewBreakdown />,
  },
  [Cover.TaxAudit]: {
    component: <ReviewTaxAudit />,
  },
} as const;

export const CompletedCovers: React.FC<{
  /** Callback for removing covers */
  remove: (covers: Cover[]) => void;
  /** Completed covers to list */
  completedCovers: Cover[];
  /** Covers to exclude that is handled outside this component */
  excludedCovers: Cover[];
}> = ({ remove, completedCovers, excludedCovers }) => (
  <>
    {completedCovers
      .filter((c) => !excludedCovers.includes(c))
      .map((cover) => (
        <FormCard key={cover} variant="content">
          {completionMap[cover]?.component}
          <RemoveCoverButton
            coversToRemove={[
              cover,
              ...((completionMap[cover]?.dependantCovers && completionMap[cover].dependantCovers) ||
                []),
            ]}
            remove={remove}
          />
        </FormCard>
      ))}
  </>
);
